import { c as _c } from "react/compiler-runtime";
import { Box, Typography } from '@mui/material';
import { RemoveCardButtonContainer } from '../ProductCardWithStickyHeader/components/RemoveCardButton.container';
import { ApplyNowSkeleton } from './ApplyNow.skeleton';
import { CardAndTitleSkeleton } from './CardAndTitle.skeleton';
export function StickyHeaderMobileSkeleton() {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <CardAndTitleSkeleton variant="compact" additionalContainerProps={{
      sx: {
        display: {
          xs: "flex",
          md: "none"
        },
        flex: "unset"
      }
    }} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      display: {
        xs: "block",
        md: "none"
      },
      flex: 1,
      mt: 2
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Box sx={t1}><ApplyNowSkeleton additionalProps={{
        padding: 0
      }} variant="compact" /></Box>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      sx: {
        display: {
          xs: "flex",
          md: "none"
        }
      }
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <>{t0}{t2}<RemoveCardButtonContainer additionalProps={t3}><Typography sx={{
          color: "neutral.lighter",
          textDecoration: "underline"
        }} data-testid="skeleton-remove-card-mobile">Remove Card</Typography></RemoveCardButtonContainer></>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}